
export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gradient-to-br from-samurai-dark via-samurai-gray to-samurai-dark text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16 lg:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-12 mb-12">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3 mb-6">
              <img 
                src="https://public.readdy.ai/ai/img_res/3bff8f98d07cd9735bb2f12a43001bf9.jpg" 
                alt="勝手屋 日本刀買取 甲冑買取 兜買取" 
                title="勝手屋ロゴ"
                className="h-12 w-auto"
              />
              <div>
                <h3 className="text-2xl lg:text-3xl font-black font-serif whitespace-nowrap">勝手屋</h3>
                <p className="text-sm text-white/80 whitespace-nowrap">日本刀・甲冑・兜の買取専門店</p>
              </div>
            </div>
            <p className="text-base lg:text-lg text-white/90 leading-relaxed mb-6">
              <strong>日本刀買取</strong>・<strong>甲冑買取</strong>・<strong>兜買取</strong>に特化した全国対応の出張買取サービスです。専門鑑定士が丁寧に査定し、適正価格で買取いたします。
            </p>
            <address className="space-y-3 not-italic">
              <div className="flex items-center gap-3">
                <i className="ri-map-pin-line text-2xl text-samurai-gold"></i>
                <span className="text-base text-white/90">神奈川県横須賀市田浦町 1-54 市営月見台住宅</span>
              </div>
              <div className="flex items-center gap-3">
                <i className="ri-time-line text-2xl text-samurai-gold"></i>
                <span className="text-base text-white/90 whitespace-nowrap">受付時間：平日 9:00〜17:00</span>
              </div>
            </address>
          </div>

          <nav>
            <h4 className="text-xl font-bold mb-6 whitespace-nowrap">サイトマップ</h4>
            <ul className="space-y-3">
              <li>
                <a
                  href="#service"
                  onClick={(e) => { e.preventDefault(); scrollToSection('service'); }}
                  className="text-base text-white/80 hover:text-samurai-gold transition-colors whitespace-nowrap"
                >
                  サービス紹介
                </a>
              </li>
              <li>
                <a
                  href="#flow"
                  onClick={(e) => { e.preventDefault(); scrollToSection('flow'); }}
                  className="text-base text-white/80 hover:text-samurai-gold transition-colors whitespace-nowrap"
                >
                  査定の流れ
                </a>
              </li>
              <li>
                <a
                  href="#guarantee"
                  onClick={(e) => { e.preventDefault(); scrollToSection('guarantee'); }}
                  className="text-base text-white/80 hover:text-samurai-gold transition-colors whitespace-nowrap"
                >
                  高価買取保証
                </a>
              </li>
              <li>
                <a
                  href="#contact"
                  onClick={(e) => { e.preventDefault(); scrollToSection('contact'); }}
                  className="text-base text-white/80 hover:text-samurai-gold transition-colors whitespace-nowrap"
                >
                  お問い合わせ
                </a>
              </li>
              <li>
                <a
                  href="#faq"
                  onClick={(e) => { e.preventDefault(); scrollToSection('faq'); }}
                  className="text-base text-white/80 hover:text-samurai-gold transition-colors whitespace-nowrap"
                >
                  よくある質問
                </a>
              </li>
            </ul>
          </nav>

          <nav>
            <h4 className="text-xl font-bold mb-6 whitespace-nowrap">お問い合わせ</h4>
            <ul className="space-y-3">
              <li>
                <a
                  href="https://lin.ee/Bi3KvRO"
                  rel="noopener noreferrer"
                  className="flex items-center gap-2 text-base text-white/80 hover:text-samurai-gold transition-colors whitespace-nowrap"
                >
                  <i className="ri-line-fill text-xl"></i>
                  LINE
                </a>
              </li>
              <li>
                <a
                  href="#contact-form"
                  onClick={(e) => { e.preventDefault(); scrollToSection('contact-form'); }}
                  className="flex items-center gap-2 text-base text-white/80 hover:text-samurai-gold transition-colors whitespace-nowrap"
                >
                  <i className="ri-mail-fill text-xl"></i>
                  メール
                </a>
              </li>
              <li>
                <a
                  href="tel:070-8453-9292"
                  className="flex items-center gap-2 text-base text-white/80 hover:text-samurai-gold transition-colors whitespace-nowrap"
                >
                  <i className="ri-phone-fill text-xl"></i>
                  電話
                </a>
              </li>
            </ul>
          </nav>
        </div>

        <div className="border-t border-white/20 pt-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-sm text-white/70 text-center md:text-left">
              &copy; 2025 勝手屋. All rights reserved.
            </p>
            <a
              href="https://readdy.ai/?ref=logo"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="text-sm text-white/70 hover:text-samurai-gold transition-colors whitespace-nowrap"
            >
              Website Builder
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
